import Header from './Header'
import Footer from './Footer'
import ParallaxBackground from './ParallaxBackground'

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col relative">
      <ParallaxBackground />
      <div className="relative z-10">
        <Header />
        <main className="flex-1">
          {children}
        </main>
        <Footer />
      </div>
    </div>
  )
}

export default Layout